import type { CropType, IPhoto, IProject } from '../common/index.js';
import { createDesigner } from '../designer/DesignerFactory.js';

export function autofillProject(project: IProject, photos: IPhoto[], cropStrategy?: CropType): IProject {
    const designer = createDesigner(project, photos, cropStrategy);

    return designer.designProject();
}
